export default "__VITE_ASSET__BNVacYKW__"